import React from 'react';
import './style.css';

function Footer () {
    return (
        <footer className="footer py-3">
            <div className="container text-center">
                <span className="text-muted">&copy; Tolga Secme, 2021, All Rights Reserved.</span>
            </div>
        </footer>
    )
}

export default Footer;